import {Component, input} from '@angular/core';
import {FormGroup, Validators} from '@angular/forms';
import {SubTableField} from './sub-table-field.model';
import {SubTableBaseComponent} from '../../base/sub-table-base.component';

@Component({
	selector: 'tvcore-sub-table',
	templateUrl: './sub-table.component.html',
	styleUrls: ['./sub-table.component.scss'],
	standalone: false
})
export class SubTableComponent<T> extends SubTableBaseComponent<T> {
	fields = input.required<SubTableField[]>();
	key = input.required<string>();
	itemName = input('lijn');

	protected override createLineGroup(item?: T): FormGroup {
		const group: any = {
			fid: [this.createFrontendID()],
		};

		this.fields().forEach(field => {
			const value = item ? (item as any)[field.name] : null;
			group[field.name] = [value || field.default, field.name !== 'id' ? Validators.required : null];
		});

		return this.fb.group(group);
	}
}
